// Quilljs throws an error in certain browsers which stops the whole page from loading.
let loaded = false;
let component = null;
try {
    require('react-quill');
    component = require('components/Shared/Forms/RichTextEditor/QuillRichTextEditor').default;
    loaded = true;
} catch (err) {
    loaded = false;
}

const RichTextEditorLoader = {
    HasLoaded: loaded,
    Component: component,
};

export default RichTextEditorLoader;
